  <!-- Dropdown Menu -->
  <div *ngIf="(isMenuOpen$ | async)"
    class="absolute top-full right-0 h-screen w-64 bg-white shadow-lg rounded-lg z-30 overflow-hidden" dir="rtl">
    <!-- Study Topics Section -->
    <div class="p-4 border-b border-gray-100">
      <h3 class="text-md font-semibold text-gray-600 mb-3">נושאי לימוד</h3>
      <ul class="space-y-2">
        <li *ngFor="let topic of topics"
        class="py-2 px-3 rounded-lg cursor-pointer transition-colors flex items-center"
        [ngClass]="{'bg-gray-100 text-gray-700': currentTopic === topic.id, 'hover:bg-gray-100': currentTopic !== topic.id}"
        (click)="selectTopic(topic.id)">
        <span class="material-icons ml-3 text-gray-600">{{topic.icon}}</span>
        <span class="flex-grow text-right">{{topic.name}}</span>
        <span class="material-icons text-gray-700 text-sm ml-2"
            [style.visibility]="currentTopic === topic.id ? 'visible' : 'hidden'">
            check
        </span>
    </li>
      </ul>
    </div>

    <!-- Learning Options Section -->
    <div class="p-4">
      <h3 class="text-md font-semibold text-gray-600 mb-3">אפשרויות לימוד</h3>
      <ul class="space-y-3">
        <li class="flex items-center cursor-pointer hover:bg-gray-100 p-2 rounded-lg" (click)="goToChapters()">
          <span class="material-icons bg-gray-100 p-2 rounded-lg text-gray-600 ml-2">menu_book</span>
          <span>רשימת הסימנים</span>
        </li>
        <li class="flex items-center cursor-pointer hover:bg-gray-100 p-2 rounded-lg" (click)="goToExams()">
          <span class="material-icons bg-gray-100 p-2 rounded-lg text-gray-600 ml-2">school</span>
          <span>שאלות ממבחנים</span>
        </li>
        <li class="flex items-center cursor-pointer hover:bg-gray-100 p-2 rounded-lg" (click)="openRandomSection()">
          <span class="material-icons bg-gray-100 p-2 rounded-lg text-gray-600 ml-2">shuffle</span>
          <span>סעיף אקראי</span>
        </li>
      </ul>
    </div>
  </div>
